<template>
  <div class="page-wrapper">
    <div class="page-head page-head--mobile-wrap">
      <div class="breadcrumbs">
        <div class="h1" v-if="permissions.read.indexOf('Бухгалтерия') != -1">
          <router-link class="link-not-like" to="/bookkeeping">{{ $vuetify.lang.t('$vuetify.menu.accounting') }}
          </router-link>
        </div>
        <svg v-if="permissions.read.indexOf('Бухгалтерия') != -1" width="9" height="15" viewBox="0 0 9 15" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1">
          {{ $vuetify.lang.t('$vuetify.menu.' + mode) }}
        </div>
      </div>


      <div class="page-head__btns">
        <BookkeepingSelect :mode="mode"></BookkeepingSelect>

        <router-link v-if="(mode=='waybills' || permissions.edit.indexOf('Бухгалтерия') != -1) && active"
                     class="btn-secondary btn link-not-like"
                     :to="$route.path + '/new'">
          + {{ $vuetify.lang.t('$vuetify.add') }}
        </router-link>
      </div>
    </div>

    <div class="page-head page-head--sorts">
      <div class="page__sorts">
        <v-menu ref="date" v-model="date" :close-on-content-click="false"
                transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-if="['purchases', 'sales'].includes(mode)" class="search-field"
                          :value="new Date(range).toLocaleDateString('ru-Ru').substr(3)"
                          @keypress.enter="loadData()" prepend-inner-icon="$calendar"
                          :placeholder="$vuetify.lang.t('$vuetify.sorts.searchObject')" outlined
                          hide-details v-bind="attrs" v-on="on" readonly>
            </v-text-field>
          </template>
          <v-date-picker v-model="range" type="month" @input="date = false"
                         no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                         show-adjacent-months></v-date-picker>
        </v-menu>
        <v-text-field class="search-field" v-if="['waybills', 'contracts', 'documents'].includes(mode)"
                      v-model="search" @keypress.enter="page=1; loadData()"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.search' + mode[0].toUpperCase() + mode.slice(1))"
                      outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>
        <v-select class="sorts__select" v-model="sort"
                  :class="{ show: type == 'cards'}"
                  :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                  :items="selectSorts" item-text="name" item-value="value"
                  :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach>
          <template v-slot:selection="{item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
          <template v-slot:item="{ item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
        </v-select>
      </div>
      <div class="page-head--right">
        <per-page-select v-model="perPage"></per-page-select>
        <div class="type-switcher">
          <div
            class="type-switcher__item"
            :class="{ show: type == 'rows' }"
            @click="type = 'rows'"
          >
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
              <path
                d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                fill="#2A3F57"
              />
              <rect
                x="0.5"
                y="0.5"
                width="33"
                height="33"
                rx="4.5"
                stroke="#2A3F57"
              />
            </svg>
          </div>
          <div
            class="type-switcher__item"
            :class="{ show: type == 'cards' }"
            @click="type = 'cards'"
          >
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                fill="#2A3F57"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                fill="#2A3F57"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                fill="#2A3F57"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                fill="#2A3F57"
              />
              <rect
                x="0.5"
                y="0.5"
                width="33"
                height="33"
                rx="4.5"
                stroke="#2A3F57"
              />
            </svg>
          </div>
          <div class="type-switcher__item type-switcher__item--settings" @click="settingsModal=true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1733_6915" fill="white">
                <path
                  d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"/>
              </mask>
              <path
                d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"
                fill="#E1EBF8" stroke="#E1EBF8" stroke-width="2" mask="url(#path-1-inside-1_1733_6915)"/>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <table class="main-table">
      <thead v-if="type == 'rows'">
      <draggable v-model="headers" tag="tr" @change="saveSettings">
        <template v-for="header in headers">
          <td :class="{sortable: !['way_time', 'dueDate'].includes(header)}" @click="set_sort(header)"
              :key="header" scope="col"
              v-if="showHeaders[header]">
            <template v-if="header == 'scan'">
              {{ $vuetify.lang.t('$vuetify.accounting.' + mode + '.scan') }}
            </template>
            <template v-else>
              {{ $vuetify.lang.t('$vuetify.accounting.card.' + header) }}
            </template>
            <v-icon class="sorts__icon" v-if="sort.includes(header)" :class="{reverse: sort[0] == '-'}">
              mdi-arrow-up
            </v-icon>
          </td>
        </template>
      </draggable>
      </thead>
      <tbody :class="{ 'cards ': type == 'cards' }">
      <div class="document__statistic" :class="{ 'cards__single ': type == 'cards' , 'hidden': type == 'rows'}"
           v-if="['purchases', 'sales'].includes(mode)">
        <h3>{{ $vuetify.lang.t('$vuetify.statistic') }}</h3>
        <div v-if="mode == 'purchases'">
          <div>{{ $vuetify.lang.t('$vuetify.accounting.statistic.count') }} {{ statistic.count }}</div>
          <div>{{ $vuetify.lang.t('$vuetify.accounting.statistic.categories') }} {{ statistic.count_categories }}</div>
          <div v-if="statistic.sum">{{ $vuetify.lang.t('$vuetify.accounting.card.sum') }} {{
              statistic.sum.toFixed(2)
            }}
          </div>
          <strong>{{ $vuetify.lang.t('$vuetify.accounting.statistic.byCategory') }}: </strong>
          <template v-for="item in statistic.by_categories">
            <div :key="item.category__name['eng']">
              {{
                item.category__name[$vuetify.lang.current] ? item.category__name[$vuetify.lang.current] : item.category__name['eng'] ? item.category__name['eng'] : item.category__name['fin']
              }} - {{ item.sum.toFixed(2) }}
            </div>
          </template>
        </div>
        <div v-if="mode == 'sales'">
          <div>{{ $vuetify.lang.t('$vuetify.accounting.statistic.perMonth') }}: {{ documents.length }}</div>
          <div>{{ $vuetify.lang.t('$vuetify.accounting.statistic.clients') }}: {{ statistic.count_clients }}</div>
          <div>{{ $vuetify.lang.t('$vuetify.accounting.statistic.sum') }} {{ statistic.sum }}</div>
          <div>{{ $vuetify.lang.t('$vuetify.accounting.statistic.sumTax') }} {{ statistic.sum_tax }}</div>
        </div>
      </div>
      <document-card
        v-for="(document, i) in documents"
        :key="document.id"
        v-model="documents[i]"
        :id="document.id"
        :path="document.path"
        :zip="document.zip"
        :photo="document.photo"
        :options="document.options"
        :type="type"
        :mode="mode"
        :headers="headers"
        :multi="document.multi"
        @edit="
                  (id) => {
                    chosen_id = id;
                  }
                "
      ></document-card>
      </tbody>
    </table>
    <div class="page-footer">
      <per-page-select v-model="perPage"></per-page-select>
      <v-pagination
        v-model="page"
        :length="length"
        @input="loadData"
      ></v-pagination>
    </div>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <v-dialog v-model="settingsModal">
      <div class="modal">
        <div class="h1">
          {{ $vuetify.lang.t("$vuetify.selectShownHeaders") }}
        </div>
        <v-form ref="form" @submit.prevent="">
          <v-checkbox v-for="header in headers" v-model="showHeaders[header]" :key="header"
                      :label="$vuetify.lang.t('$vuetify.accounting.card.' + header)"></v-checkbox>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="settingsModal=false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="saveSettings">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import DocumentCard from "./parts/DocumentCard.vue";
import SpinnerLoader from "@/components/SpinnerLoader";
import draggable from "vuedraggable";
import PerPageSelect from "@/components/PerPageSelect.vue";
import {mapActions, mapGetters} from "vuex";
import BookkeepingSelect from "@/components/BookkeepingSelect.vue";

export default {
  name: "documents-list",
  components: {
    BookkeepingSelect,
    PerPageSelect,
    DocumentCard,
    SpinnerLoader,
    draggable,
  },
  props: {
    mode: [Number, String]
  },

  data: function () {
    return {
      selectedSection: this.mode,
      sections: [
          'documents-absence',
          'documents-timings',
          'timingChangesList',
          'reports',
          'extracts',
          'contracts',
          'documents',
          'property',
          'purchases',
          'sales',
          'offers',
          'waybills',
          'garage',
      ],
      url: "",
      headers: [],
      type: localStorage.getItem("type_documents") ?? (window.screen.width < 600 ? "cards" : "cards"),
      page: 1,
      perPage: Number(localStorage.getItem("per_page") ?? 24),
      length: 0,

      chosen_id: 0,

      sort: "",
      search: "",
      range: new Date().toISOString().substr(0, 7),
      selectSorts: [],
      documents: [],
      statistic: {
        by_categories: []
      },

      date: false,
      menuStart: false,
      menuEnd: false,
      alertError: false,
      alertMsg: "",
      loader: false,

      settingsModal: false,
      tableSettings: {},
      showHeaders: {},
    };
  },

  watch: {
    selectedSection: function(val){
      switch (val) {
        case 'documents-absence':
          this.$router.push({
            name: 'documents-absence'
          })
          break;
        case 'documents-timings':
          this.$router.push({
            name: 'documents-timings'
          })
          break;
        case 'timingChangesList':
          this.$router.push({
            name: 'timingChangesList'
          })
          break;
        default:
          this.$router.push({
            name: 'documents', params: {
              mode: val
            }
          })
          break;
      }


    },

    type: function (val) {
      localStorage.setItem("type_documents", val);
    },
    sort: function () {
      this.page = 1
      this.loadData()
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.documents.length))
        this.page = 1
      this.loadData()
    },
    range: function () {
      this.loadData()
    },
  },

  created: function () {
    if (this.mode == 'waybills') {
      this.launch()
    } else{
      this.checkPermission('Бухгалтерия').then(()=>{
        this.launch()
      })
    }
  },

  methods: {
    ...mapActions(['checkPermission']),
    launch(){
      if (this.mode == 'contracts') {
        this.url = "time-tracking/accounting/documents-client/" + this.mode
      } else {
        this.url = "time-tracking/accounting/documents/" + this.mode
      }
      switch (this.mode) {
        case "reports":
          this.headers = [
            'scan',
            'period',
            'category',
            'author',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCategory') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCategory",
              direction: "sortAscending",
              value: 'category'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCategory') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCategory",
              direction: "sortDescending",
              value: '-category'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byDate",
              direction: "sortAscending",
              value: 'period'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byDate",
              direction: "sortDescending",
              value: '-period'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAccountant') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byAccountant",
              direction: "sortAscending",
              value: 'author'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAccountant') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byAccountant",
              direction: "sortDescending",
              value: '-author'
            },
          ]
          break
        case "extracts":
          this.headers = [
            'scan',
            'bank',
            'period',
            'author',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byDate",
              direction: "sortAscending",
              value: 'period'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byDate",
              direction: "sortDescending",
              value: '-period'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAccountant') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byAccountant",
              direction: "sortAscending",
              value: 'author'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAccountant') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byAccountant",
              direction: "sortDescending",
              value: '-author'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byBank') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byBank",
              direction: "sortAscending",
              value: 'bank'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byBank') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byBank",
              direction: "sortDescending",
              value: '-bank'
            },
          ]
          break
        case "contracts":
          this.headers = [
            'scan',
            'name',
            'date',
            'subject',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byName",
              direction: "sortAscending",
              value: 'name'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byName",
              direction: "sortDescending",
              value: '-name'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCreateDate",
              direction: "sortAscending",
              value: 'create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCreateDate",
              direction: "sortDescending",
              value: '-create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byClient') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byClient",
              direction: "sortAscending",
              value: 'client'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byClient') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byClient",
              direction: "sortDescending",
              value: '-client'
            },
          ]
          break
        case "documents":
          this.headers = [
            'scan',
            'name',
            'date',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byName",
              direction: "sortAscending",
              value: 'name'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byName",
              direction: "sortDescending",
              value: '-name'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCreateDate",
              direction: "sortAscending",
              value: 'create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCreateDate",
              direction: "sortDescending",
              value: '-create_date'
            },
          ]
          break
        case "property":
          this.headers = [
            'scan',
            'cost',
            'status',
            'address',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byStatus') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byStatus",
              direction: "sortAscending",
              value: 'status'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byStatus') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byStatus",
              direction: "sortDescending",
              value: '-status'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAddress') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byAddress",
              direction: "sortAscending",
              value: 'address'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAddress') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byAddress",
              direction: "sortDescending",
              value: '-address'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCost",
              direction: "sortAscending",
              value: 'cost'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCost",
              direction: "sortDescending",
              value: '-cost'
            },
          ]
          break
        case "garage":
          this.headers = [
            'scan',
            'car',
            'cost',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCar') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCar",
              direction: "sortAscending",
              value: 'car'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCar') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCar",
              direction: "sortDescending",
              value: '-car'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCost",
              direction: "sortAscending",
              value: 'cost'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCost",
              direction: "sortDescending",
              value: '-cost'
            },
          ]
          break
        case "purchases":
          this.url = "time-tracking/cheque/purchases"
          this.headers = [
            'scan',
            'category',
            'sum',
            'place',
            'date',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCost",
              direction: "sortAscending",
              value: 'sum'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCost",
              direction: "sortDescending",
              value: '-sum'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byDate",
              direction: "sortAscending",
              value: 'date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byDate",
              direction: "sortDescending",
              value: '-date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCategory') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCategory",
              direction: "sortAscending",
              value: 'category'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCategory') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCategory",
              direction: "sortDescending",
              value: '-category'
            },
            this.sort = '-date'
          ]
          break
        case "sales":
          this.url = "time-tracking/cheque/sales"
          this.headers = [
            'id',
            'scan',
            'client',
            'sum',
            'status',
            'dateCreate',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCost",
              direction: "sortAscending",
              value: 'sum'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCost",
              direction: "sortDescending",
              value: '-sum'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCreateDate",
              direction: "sortAscending",
              value: 'create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCreateDate",
              direction: "sortDescending",
              value: '-create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byStatus') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byStatus",
              direction: "sortAscending",
              value: 'status'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byStatus') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byStatus",
              direction: "sortDescending",
              value: '-status'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.bySubject') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "bySubject",
              direction: "sortAscending",
              value: 'client'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.bySubject') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "bySubject",
              direction: "sortDescending",
              value: '-client'
            },
          ]
          break
        case "offers":
          this.url = "time-tracking/offer"
          this.headers = [
            'scan',
            'client',
            'sum',
            'dateCreate',
            'dueDate',
          ]
          this.sort = '-create_date'
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCost",
              direction: "sortAscending",
              value: 'sum'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCost') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCost",
              direction: "sortDescending",
              value: '-sum'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byCreateDate",
              direction: "sortAscending",
              value: 'create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byCreateDate",
              direction: "sortDescending",
              value: '-create_date'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.bySubject') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "bySubject",
              direction: "sortAscending",
              value: 'client'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.bySubject') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "bySubject",
              direction: "sortDescending",
              value: '-client'
            },
          ]
          break
        case "waybills":
          this.url = "time-tracking/waybill"
          this.headers = [
            'scan',
            'date_start',
            'way_time',
            'mileage',
            'departure',
            'destination',
          ]
          this.selectSorts = [
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byDate",
              direction: "sortDescending",
              value: 'date_start'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byDate",
              direction: "sortDescending",
              value: '-date_start'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAddress') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byAddress",
              direction: "sortAscending",
              value: 'address'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byAddress') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byAddress",
              direction: "sortDescending",
              value: '-address'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byMileage') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
              type: "byMileage",
              direction: "sortAscending",
              value: 'mileage'
            },
            {
              name: this.$vuetify.lang.t('$vuetify.sorts.byMileage') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
              type: "byMileage",
              direction: "sortDescending",
              value: '-mileage'
            },
          ]
          break
        default:
          this.$router.push({name: "404"})
      }
      this.loadData();
      this.loadSettings();
    },
    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + this.url,
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          sort: this.sort,
          search: this.search,
          range: ['purchases', 'sales'].includes(this.mode) ? JSON.stringify(this.range) : null,
          page: this.page,
          per: this.perPage,
          worker: this.$route.name == "waybills" ?? true
        }
      }).then((response) => {
        this.documents = [];
        if (response.data.data.data) {
          this.documents = response.data.data.data;
          if (response.data.data.statistic) {
            this.statistic = response.data.data.statistic
          }
          this.length = response.data.data.pages
          for (let i = 0; i < this.documents.length; i++) {
            if (this.documents[i].path) {
              // eslint-disable-next-line no-constant-condition
              while (typeof this.documents[i].path == "string") {
                this.documents[i].path = JSON.parse(this.documents[i].path)
              }
              this.documents[i].path.forEach(doc => {
                if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.substr(doc.lastIndexOf('.') + 1))) {
                  this.documents[i].photo = doc
                }
              })
            }
            this.documents[i].options = this.documents[i].options ?? {}
            if (this.mode == 'contracts' || this.mode == 'documents') {
              this.documents[i].options.name = this.documents[i].name
              this.documents[i].options.date = new Date(this.documents[i].create_date).toLocaleDateString('ru-Ru')
            }
            if (this.mode == 'contracts')
              this.documents[i].options.subject = this.documents[i].client ? this.documents[i].client.name : ''
            if (this.documents[i].options.period)
              this.documents[i].options.period = this.documents[i].options.period.join(' ~ ')
            if (this.mode == 'property') {
              this.documents[i].options.address = this.documents[i].options.object.street + ' ' + this.documents[i].options.object.house + (this.documents[i].options.object.entrance ? (' ' + this.documents[i].options.object.entrance + ' ') : '') + (this.documents[i].options.object.flat ? (' ' + this.documents[i].options.object.flat + ', ') : ', ') + this.documents[i].options.object.index + ' ' + this.documents[i].options.object.city + ', ' + this.documents[i].options.object.country
              delete this.documents[i].options.object
            }
            if (this.mode == 'garage') {
              this.documents[i].options.car = this.documents[i].options.car.name
            }
            if (this.mode == 'reports' || this.mode == 'extracts')
              this.documents[i].options.author = this.documents[i].author.name + " " + this.documents[i].author.lastname
            if (this.mode == 'purchases') {
              this.documents[i].options.category = this.documents[i].category.name
              this.documents[i].options.sum = (this.documents[i].price).toFixed(2)
              this.documents[i].options.place = this.documents[i].place
              this.documents[i].options.date = new Date(this.documents[i].date).toLocaleDateString('ru-Ru')
              if (this.documents[i].path.length > 1) {
                this.documents[i].multi = true
              }
            }
            if (this.mode == 'sales') {
              this.documents[i].options.id = this.documents[i].id
              this.documents[i].options.client = this.documents[i].client ? this.documents[i].client.name : ''
              this.documents[i].options.sum = 0
              this.documents[i].items.forEach(item => {
                this.documents[i].options.sum += item.price * item.quantity * (1 - item.discount / 100)
              })
              this.documents[i].options.sum = Number(this.documents[i].options.sum).toFixed(1)
              this.documents[i].options.status = this.documents[i].status
              this.documents[i].options.dateCreate = new Date(this.documents[i].create_date).toLocaleDateString('ru-Ru')
            }
            if (this.mode == 'offers') {
              this.documents[i].options.client = this.documents[i].client.name
              this.documents[i].options.sum = 0
              this.documents[i].items.forEach(item => {
                this.documents[i].options.sum += item.price * item.quantity * (1 - item.discount / 100)
              })
              this.documents[i].options.sum = Number(this.documents[i].options.sum).toFixed(1)
              this.documents[i].options.dateCreate = new Date(this.documents[i].create_date).toLocaleDateString('ru-Ru')
              let date = new Date(this.documents[i].create_date)
              date.setDate(date.getDate() + this.documents[i].term.days)
              this.documents[i].options.dueDate = date.toLocaleDateString('ru-Ru')
            }
            if (this.mode == 'waybills') {
              this.documents[i].options.date_start = new Date(this.documents[i].date_start).toLocaleDateString('ru-Ru')
              let start = new Date(this.documents[i].date_start + " " + this.documents[i].time_start)
              let end = new Date(this.documents[i].date_end + " " + this.documents[i].time_end)
              let diff = end - start
              let days = Math.floor(diff / 1000 / 60 / 60 / 24)
              diff -= days * 24 * 60 * 60 * 1000
              let hours = Math.floor(diff / 1000 / 60 / 60)
              diff -= hours * 60 * 60 * 1000
              let minutes = diff / 1000 / 60
              this.documents[i].options.way_time = (days > 0 ? days + ' дней ' : '') + (hours > 0 ? (hours + ' часов ') : '') + (minutes > 0 ? (minutes + ' минут') : '')
              this.documents[i].options.mileage = this.documents[i].kilometrage_end - this.documents[i].kilometrage_start
              this.documents[i].options.departure = this.documents[i].departure
              this.documents[i].options.destination = this.documents[i].destination
            }
          }
        }
      }).catch((error) => {
        this.alertMsg = this.$catch(error)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    loadSettings() {
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.tableSettings = response.data.data.data
        if (response.data.data.data && response.data.data.data.documents && response.data.data.data.documents[this.mode]) {
          this.showHeaders = response.data.data.data.documents[this.mode]
        } else {
          switch (this.mode) {
            case 'reports':
              this.showHeaders = {
                scan: true,
                period: true,
                category: true,
                author: true,
              }
              break;
            case 'extracts':
              this.showHeaders = {
                scan: true,
                bank: true,
                period: true,
                author: true,
              }
              break;
            case 'contracts':
              this.showHeaders = {
                scan: true,
                name: true,
                date: true,
                subject: true,
              }
              break;
            case 'documents':
              this.showHeaders = {
                scan: true,
                documentName: true,
                date: true,
              }
              break;
            case 'property':
              this.showHeaders = {
                scan: true,
                cost: true,
                status: true,
                address: true,
              }
              break;
            case 'garage':
              this.showHeaders = {
                scan: true,
                car: true,
                cost: true,
              }
              break;
            case 'purchases':
              this.showHeaders = {
                scan: true,
                category: true,
                sum: true,
                place: true,
                date: true,
              }
              break;
            case 'sales':
              this.showHeaders = {
                scan: true,
                client: true,
                sum: true,
                status: true,
                date: true,
              }
              break;
            case 'offers':
              this.showHeaders = {
                scan: true,
                client: true,
                sum: true,
                dateCreate: true,
                dueDate: true,
              }
              break;
            case 'waybills':
              this.showHeaders = {
                scan: true,
                date_start: true,
                way_time: true,
                mileage: true,
                departure: true,
                destination: true,
              }
              break;
          }
        }
        let order = []
        this.headers.forEach(header => {
          order.splice(this.showHeaders.order.indexOf(header), 0, header)
        })
        this.headers = order
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    saveSettings() {
      let order = []
      this.headers.forEach(header => {
        order.push(header)
      })
      this.showHeaders.order = order
      if (this.tableSettings.documents == undefined) {
        this.tableSettings.documents = {}
      }
      this.tableSettings.documents[this.mode] = this.showHeaders

      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          table_settings: JSON.stringify(this.tableSettings)
        }
      }).then(() => {
        this.settingsModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    set_sort(field) {
      if (['way_time', 'dueDate'].includes(field))
        return
      if (this.sort.includes(field) && this.sort[0] != '-') {
        this.sort = '-' + field
      } else {
        this.sort = field
      }
    },
  },

  computed: {
    ...mapGetters(['permissions']),
    ...mapGetters(['active']),
  }
};
</script>
